var styles = {"loader":"styles_loader__WKA0s flex flex-auto items-center justify-center"};

export default styles;
//# sourceMappingURL=styles.css.js.map
